import { render } from "./UsersManagement.vue?vue&type=template&id=75651b80&scoped=true&ts=true"
import script from "./UsersManagement.vue?vue&type=script&lang=ts"
export * from "./UsersManagement.vue?vue&type=script&lang=ts"

import "./UsersManagement.vue?vue&type=style&index=0&id=75651b80&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75651b80"]])

export default __exports__